class PersistentVisibility extends HTMLElement {
  static get observedAttributes() {
    return ["class"]
  }

  connectedCallback() {
    this.restoreVisibility()
    this.restored = true
  }

  disconnectedCallback() {
    this.restored = false
  }

  attributeChangedCallback(_attrName, _oldValue, _newValue) {
    // A class change during the initial parse or during restoreVisibility must
    // not persist: it would overwrite a stored preference with the server
    // default. Only changes after restoration are genuine. - Aaron, Sun Jul 26 2026
    if (!this.restored) {
      return
    }

    this.persistVisibility()
  }

  restoreVisibility() {
    const key = this.getStorageKey()
    const visibility = sessionStorage.getItem(key)

    if (visibility == "hidden") {
      this.classList.add("hidden")
    } else if (visibility == "visible") {
      this.classList.remove("hidden")
    } else {
      // With no stored preference, persist the server-rendered default so it
      // carries across navigations within the tab. - Aaron, Sun Jul 26 2026
      this.persistVisibility()
    }
  }

  persistVisibility() {
    const key = this.getStorageKey()
    const visibility = this.classList.contains("hidden") ? "hidden" : "visible"

    sessionStorage.setItem(key, visibility)
  }

  getStorageKey() {
    let key = this.getAttribute("key")
    key ||= this.id

    if (!key) {
      throw new Error("persistent-visibility requires a key or id attribute")
    }

    return `persistent-visibility:${key}`
  }
}

if (!window.customElements.get("persistent-visibility")) {
  window.PersistentVisibility = PersistentVisibility
  window.customElements.define("persistent-visibility", PersistentVisibility)
}
